

export let enMessages={
  //
  "BG Export":"BG",

  // 2020.3.24 增加
  "Pump_Alarm_Alerts_On_Pump":"Pump Alarms & Alerts On Pump",
  "EasyLoop":"EasyLoop",
  "Time":"Time",
  "Title":"Title",
  "Reminders":"Reminders",
  "Height Unit":"Height Unit",
  "Weight Unit":"Weight Unit",
  "Audio Option":"Audio Option",
  "APP":"APP",
  "Tone":"Tone",
  "Alerts for Others":"Alerts for Others",
  "Alerts for High":"Alerts for High",
  "Alerts for Low":"Alerts for Low",
  "Factory Calibration":"Factory Calibration",
  "Transmitter SN":"Transmitter SN",
  "Pump Alerts on App":"Pump Alerts on App",
  "Pump Alarms on App":"Pump Alarms on App",
  "Command Reminder":"Command Reminder",
  "Pump Base SN":"Pump Base SN",
  "Audio":"Audio",
  "Once":"Once",

  // 2020.3.17 增加
  "country_region":"Country/region",
  "hcp_apply_user_exist":"This email address has been used by a patient/caregiver account. If you want to switch to an HCP account, choose Next.<br/><br/>" +
    "Please note that once the account type is changed, any account data will be lost, and you can’t log in anymore to your patient/caregiver account on EasyTouch/EasySense/EasyFollow.",
  "check_email_for_code":"Please check your email XXX@XXX.com for the verification code. ",
  "try_again":"Try again.",
  "account_type_changed":"Account type changed.",
  "application_has_been_submitted":"Your application has been submitted. Once your application status changes, an email will be sent informing you. ",

  //
  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  //"privacy_confirm_text" : "We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_text" : "We have updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>privacy policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>terms of use</a>. Please read and agree to all terms to continue using EasyView.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",

  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"Email",
  "password":"Password",
  "remember":"Remember Me",
  "forget":"Forgot Password?",
  "sign in":"Sign in",
  "login":"Login",
  "sign up now":"Sign up now",
  "apply":"Apply for an account",
  "contact us":"Contact Us",
  "Privacy Policy":"Privacy Policy",
  "Terms of Use":"Terms of Use",
  "copyright":"Copyright © 2021 Medtrum Technologies Inc. All rights reserved.",

  "chooseLang":"Choose your country/region or language",
  "asia":"Asia Pacific",
  "europe":"Europe",
  "middleEast":"Middle East",

  "applyHcp":"Apply for an HCP account",
  "sign up":"Sign up",
  "Patient":"Patient",
  "Caregiver":"Caregiver",
  "Email":"Email",
  "Mobile":"Mobile",
  "Enter email":"Enter email address",
  "Enter mobile":"Enter mobile number",
  "Verification":"Verification code",
  "Invitation":"Invitation code",
  "full name":"Enter your full name",
  "Enter pass":"Enter password",
  "org":"Organization",
  "Register":"Register",
  "send":"Send",
  "createAccount":"Create Account",
  "agree":"I have read and agree to the ",
  "privacy":" Medtrum privacy policy  ",
  "and" :"and ",
  "use":"terms of service.",
  "errtip1-1":"You must enter a valid email address,which",
  "errtip1-2":"will become your Medtrum username.",
  "errtip2":"Please enter a valid mobile number.",
  "errtip3":"Verification code incorrect",
  "errtip4":"Incorrect invitation code.",
  "errtip5":"Username incorrect",
  "errtip6":"Your password must have 8 or more characters.",
  "errtip7":"Please enter your organization.",

  "errp1":"Password must contain at least 3 types of the following characters:",
  "errp2":"capital letter,lowercase letter, number and special character.",
  "errp3":"Password must be between 6 and 20 characters long.",
  "errp4":"Password must be different from username.",
  "errp5":"Password with 3 consecutive numbers is invalid (e.g.: 123, 321).",
  "errp6":"Password with 3 consecutive letters is invalid (e.g.: abc, cba).",
  "errp7":"Password cannot contain spaces.",


  "Find account":"Retrieve your password.",
  "Enter username":"Please enter your username.",
  "Next":"Next",
  "Cancel":"Cancel",
  "Back":"Back",
  "Enter veri":"Enter verification code",
  "Verify notice":"Please find the verification code sent in an email.",
  "Create new":"Create a new password",
  "Create new notice":"Please create a new password，and your password must have 6 or more characters.",
  "New pass" :"New password",
  "Completed":"Completed",
  "Created":"New password created.",
  "Login Now":"Sign in now",

  "Delete":"Delete",
  "New Patient":"New Patient",
  "Add Patient":"Add Patient",
  "Filter":"Filter",
  "Name":"Name",
  "Gender":"Gender",
  "Age":"Age",
  "Type":"Type",
  "Duration":"Duration",
  "Connections":"Account creator",
  "UploadTime":"Upload time",
  "Year":"year",
  "Years":"years",
  "Month":"month",
  "Month2":"Month",
  "Months":"months",
  "Invite":"Invite",
  "Invited":"Invited",
  "All":"All",
  "Female":"Female",
  "Male":"Male",
  "Not Set":"Not Set",
  "Type 1":"Type 1",
  "Type 2":"Type 2",
  "Gestational":"Gestational",
  "Prediabetes":"Prediabetes",
  "LADA":"Type 1.5 LADA",
  "Apply":"Apply",
  "disUn":"Diabetes type unspecified", // update
  "ageUn":"Age unspecified",
  "genUn":"Gender unspecified",
  "addP":"Add Patient",
  "newP":"New Patient",
  "findP":"Find Patient",

  "GDRNF":"Unspecified",
  "GDRF":"Female",
  "GDRM":"Male",
  "女":"Male",

  "DBTNF":"Unspecified",
  "DBT1":"Type 1",
  "DBT2":"Type 2",
  "DBTLADA":"Type 1.5 LADA",
  "DBTPRE":"Prediabetes",
  "DBTGEST":"Gestational",
  "前期":"beFore",
  "beFore":"beFore",
  "MODY":"Mody",

  "No selection":"No selection",
  "unspecif":"unspecified",
  "register":"Patient",
  "hcp":"Clinician",

  "BG":"BG",
  "CARB":"Carbs",
  "INS":"Injection",
  "EXR":"Exercise",
  "OTR":"Other",
  "HBA1C":"HbA1c",
  "DOSE":"DOSE",
  "URINEK":"Urine Ketone",
  "HEL":"HEL",
  "OTR1":"Other",
  "Loading":"Loading",

  "home":"Home",
  "pID":"Patient ID",
  "fullName":"Full name",
  "gender":"Gender",
  "height":"Height",
  "weight":"Weight",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Date of birth",
  "disType":"Type of diabetes",
  "disDate":"Date of diagnosis",
  "Address":"Address",
  "Postcode":"Postcode",
  "Inpatient":"Inpatient",
  "Yes":"Yes",
  "No":"No",
  "Pno":"Patient no.",
  "Bno":"Bed no.",
  "create":"Create",
  "Telephone":"Telephone",

  "enterU":"Enter username (email)",
  "search":"Search",
  "noU":"Username is required.",
  "searchR":"Search results",
  "uername":"Username",
  "alias":"Alias",
  "remove":"Remove",
  "viewG":"View graphs",
  "sendR":"Send request",
  "rSent":"Your request has been sent.",
  "cancelR":"Cancel request",

  "VcodeTip1":"Didn’t receive it? Please wait for a few minutes and",
  "VcodeTip2":"try again.",
  "VcodeTip3":"We just sent a code to ",
  "Entercode":"Enter code",
  "Getcode":"Get code",

  "messages":"Messages",
  "profile":"Profile",
  "sign out":"Sign out",
  "changeP":"Change Password",
  "connection":"Connections",

  "myP":"My profile",
  "Portrait":"Profile photo",
  "Profession":"Profession",
  "DPRONF":"Unspecified",
  "DPROENDOCRIN":"Endocrinologist",
  "DPRODIABTRA":"Diabetes Educator",
  "DPRONURSE": "Nurse",
  "DPRODIATIT":"Dietitian",
  "DPROOTR": "Other HCPs",
  "Organization":"Organization",
  "Bio":"Bio",
  "save":"Save",
  "oldPa":"Old password ",
  "newPa":"New password",
  "RePa":"Re-enter password",
  "forgetY":"Forgot your password?", // update
  "applyM":"Apply",
  "oldErr":"The old password is incorrect.",
  "EntTheSame":"Enter the new password again.",
  "EnterOld":"Enter the old Password!",

  "pList":"Patient List",
  "connections":"Connections",
  "settings":"Settings",
  "monitor":"Monitor",
  "graphs":"Reports",
  "events":"Events",
  "records":"Records",
  "qPrint":"Quick Print",

  "sensorIn":"Sensor Info",
  "timeOfLaRead":"Time of the last sensor reading",
  "tranSn":"Transmitter SN",
  "status":"Status",
  "sensorLife":"Sensor life left",
  "lastSenorRead":"Last sensor reading",
  "TranBattery":"Transmitter battery",
  "sg":"SG",
  "alert":"Alert",
  "target":"Target",
  "hypo":"Hypo",
  "sensorGlucose":"Sensor Glucose",
  "calib":"Calibration",
  "newSen":"New Sensor",
  "warm":"Warm up",
  "InsulinPump":"Insulin Pump",
  "timeOfLaPump":"Time of the last pump data",
  "pumpSN":"Pump Base SN",
  "ReserviorLife":"Reservoir patch life left",
  "InsulinLeft":"Insulin left",
  "basal":"Basal",
  "bolus":"Bolus",
  "totalBasal":"Total daily basal",
  "lastBolus":"Last bolus",
  "activeInsulin":"Active insulin",
  "totalBolus":"Total daily bolus",
  "tampBasal":"Temp Basal",
  "normalBolus":"Normal Bolus",
  "extendBolus":"Extended Bolus",
  "manualStop":"Manual Suspend",
  "autoStop":"Auto Suspend",
  "auto suspend":"Auto Suspend",
  "stop":"Delivery Stop",
  "newPatch":"New Patch",
  "tempBasal":"Temp Basal",
  "N":"N",
  "E":"E",
  "CN1":"CN",
  "CE":"CE",

  "staticSettings":"Report Settings",
  "dataSource":"Data to view",
  "unit":"Unit",
  "glucoseTarget":"Glucose Target Range", // update
  "overall":"Overall",
  "Hypoglycemia":"Hypoglycaemia", // update
  "timePeriod":"Time Period",
  "postMeal":"Post Meal Analysis",
  "Breakfast":"Breakfast",
  "Lunch":"Lunch",
  "Dinner":"Dinner",
  "night":"Night-time",
  "Before":"Before",
  "After":"After",
  "Low":"Low",
  "High":"High",
  "From":"From",
  "To":"To",
  "Hours":"hours",
  "Reset":"Restore defaults",
  "RealTime":"Real-time",
  "uploaded":"Uploaded",
  "sensor":"Sensor",
  "pdmSN":"PDM SN",
  "startTime":"Start time",
  "endTime":"End time",
  "uploadTime":"Time of upload",
  "pdm":"PDM",
  "Uploaded":"Uploaded",
  "Patch Pump":"Patch Pump",
  "overLapp":"Sessions overlapped",
  "showAlert":"Show alerts",

  "dashboard":"Dashboard",
  "dboard_glucose_statistics":"Glucose Statistics",
  "dboard_glucose":"BG",
  "dboard_cgm":"CGM",
  "dboard_insulin":"Insulin",
  "dboard_carbs":"Carbs",
  "dboard_exercise":"Exercise",
  "dboard_glucose_avg":"Average",
  "dboard_cgm_avg":"Average",
  "dboard_insulin_avg":"Average Daily Dose",
  "dboard_carbs_avg":"Average Carbs/Day",
  "dboard_exercise_avg":"Average time/Day",
  "dboard_sd":"SD",
  "dboard_num":"#",
  "dboard_num_days":"# days",
  "dboard_statistics":"Statistics",
  "dboard_BG":"BG",
  "dboard_BG_calibration":"BG / calibration (per day)",
  "dboard_SG":"SG",
  "dboard_AUC_high":"AUC high >",
  "dboard_AUC_low":"AUC low <",
  "dboard_highest_value":"Highest value",
  "dboard_lowest_value":"Lowest value",

  "dboard_pump":"Pump",
  "dboard_avg_daily_dose":"Average Daily Dose",
  "dboard_SD":"SD",
  "dboard_daily_basal":"Daily Basal",
  "dboard_daily_bolus":"Daily Bolus",
  "dboard_avg_bolus_num":"Average Bolus No. (per day)",
  "dboard_avg_suspend_time":"Average Suspend time (per day)",
  "dboard_avg_reservoir_usage":"Average Reservoir usage (per day)",
  "dboard_days":"days",

  "dboard_manual_bolus":"Manual Bolus (Volume/No. per day)",
  "dboard_normal":"-Normal",
  "dboard_extend":"-Extended",
  "dboard_combo":"-Combo",

  "dboard_bolus_calculator":"Bolus Calculator (Volume/No. per day)",
  "dboard_food_bolus":"-Food Bolus calc.",
  "dboard_corr_bolus":"-Corr Bolus calc.",
  "dboard_override_add":"-Override(+)",
  "dboard_override_sub":"-Override(-)",

  "dboard_report":"Dashboard Report",

  "daily":"Daily Summary",
  "date":"Date",
  "print":"Print",
  "carbs":"Carbs",
  "exercise":"Exercise",
  "heavy":"Heavy",
  "Medium":"Medium",
  "Light":"Light",
  "dailyReport":"Daily Summary Report",
  "devices":"Devices",
  "tran":"Transmitter",
  "pumpBase":"Pump Base",
  "HbA1c":"HbA1c",
  "statics":"Statistics",
  "glucose":"Glucose",
  "item":"Item",
  "BG1":"BG",
  "SG1":"SG",
  "avgSD":"Avg. (mmol/L)±SD",
  "avgSD1":"Avg±SD",
  "min":"Min",
  "max":"Max",
  "ofRead":"# of readings",
  "ofHypo":"# of hypo/duration(min)",
  "ofAlert":"# of alerts",
  "insulin":"Insulin",
  "insulin2":"Insulin",
  "totalDose":"Total daily dose",
  "foodBolus":"Food Bolus",
  "Food+coor":"Food+corr",
  "calibBolus":"Correction Bolus",
  "durationStop":"Duration of suspension(min)",
  "ofPumpAlert":"# of pump alarms",
  "ofMeal":"# of meals",
  "totalExerTime":"Total exercise time",
  "exerNum":"# of exercises",
  "avgInten":"Avg. Intensity",
  "target1":"Target",
  "high1":"High",
  "low1":"Low",
  "BG Reading":"BG Reading",

  "dayByday":"Day by Day Overview",
  "dayBydayRe":"Day by Day Overview Report",
  "period":"Period",

  "sensorOverlay":"Sensor Overlay",
  "set":"Set",
  "setPeriod":"Set period",
  "Weekdays":"Weekdays",
  "Weekends":"Weekends",
  "Mon":"Mon",
  "Tue":"Tue",
  "Wed":"Wed",
  "Thur":"Thu", // update
  "Thu":"Thu", // update
  "Fri":"Fri",
  "Sat":"Sat",
  "Sun":"Sun",
  "Average":"Average",
  "sensorOlRe":"Sensor Overlay Report",
  "Avg":"Avg.", // update
  "±SD":"±SD",
  "ofhypo":"# of Hypo",
  "Everyday":"every day",

  "TrendAna":"Trend Analysis",
  "TrendRe":"Trend Analysis Report",
  "sensorGlu":"Sensor Glucose ",
  "ofBGtest":"# of BG tests",
  "Basics":"Basics",
  "static":"Statistics",
  "Med":"Med",
  "med":"median",
  "Q1":"Q1",
  "Q3":"Q3",
  "Q11":"Q1",
  "Q31":"Q3",
  "IQR":"IQR",
  "SD":"SD",
  "CV":"CV",
  "SE1":"SE Mean",
  "distri":"Distribution",
  "stab":"Stability",
  "#high":"# of high",
  "#low":"# of low",
  "aucBelow":"AUC Below limit",
  "aucAbove":"AUC Above limit",
  "bgRead":"BG readings",
  "total":"Avg. Daily Total",
  "avg_daily_basal":"Avg. Daily Basal",
  "avg_daily_bolus":"Avg. Daily Bolus",
  "ofBolus":"Avg. # of bolus/Day",
  "avgBolus":"Avg. bolus(U)/Each",
  "Dura1":"Duration (min)",
  "Avg/Total":"Avg/Total",
  "high":"High",
  "low":"Low",
  "#hypo":"# of Hypo",
  "ofExer":"# of Exercises",

  "logbook":"Logbook",
  "dailyTotal":"Daily Total",
  "High Glucose":"High Glucose",
  "Low Glucose":"Low Glucose",
  "No Active Patch":"No Active Patch",
  "Missed Meal":"Missed Meal",
  "Multiple BG Readings":"Multiple BG Readings",
  "Stop Patch":"Stop Patch",
  "Others":"Others",
  "Other Events":"Other Events",
  "logRe":"Logbook Report",

  "DeviceSetting":"Device Settings Review",
  "Insulin Pump":"Insulin Pump",
  "MaxBasalRate":"Maximum Basal Rate",
  "BasalPatterns":"Basal Patterns",
  "Selected Basal Pattern":"Selected Basal Pattern",
  "Maximum Bolus":"Maximum Bolus",
  "Combo/Extended Bolus":"Combo/Extended Bolus",
  "BG Reminder":"BG Reminder",
  "Bolus Increment":"Bolus Increment",
  "Bolus Calculator":"Bolus Calculator",
  "Active Insulin Time":"Active Insulin Time",
  "IC Ratios":"IC Ratios",
  "Insulin Sensitivity":"Insulin Sensitivity",
  "BG Target":"BG Target",
  "Bolus Reminder":"Bolus Reminder",
  "CGM":"CGM",
  "CGM System":"CGM System",
  "Glucose Unit":"Glucose Unit",
  "Glucose Limits":"Glucose Limits",
  "Predicitive Alerts":"Predictive Alerts", // update
  "Rate Alerts":"Rate Alerts",
  "type":"Type",
  "time":"Time",
  "data":"Data",
  "Rate":"Rate",
  "Calibration Reminder":"Calibration Reminder",
  "Calibration Repeat":"Calibration Repeat",
  "Snooze":"Snooze",
  "Audio Options":"Audio Options",
  "Confidence Reminder":"Confidence Reminder",
  "Backlight":"Backlight",
  "Sec":"sec",
  "Alarm Clock":"Alarm Clock",
  "Patch Expiration":"Patch Expiration",
  "Sensor Expiration":"Sensor Expiration",
  "Hourly Max":"Hourly Max",
  "Daily Max":"Daily Max",
  "Low Reservoir":"Low Reservoir",
  "Low Suspend":"Low Suspend",
  "Predictive Low Suspend":"Predictive Low Suspend",
  "Rise":"Rise",
  "Fall":"Fall",
  "Auto Off":"Auto Off",
  "Standard":"Standard",
  "Exercise":"Exercise",
  "Holiday":"Holiday",
  "ProgramA":"Pattern A",
  "ProgramB":"Pattern B",
  "--":"--",
  "Insulin":"Insulin",

  "SUSA":"Auto Off",
  "SUSHM":"Exceeds Max 1 Hour Delivery",
  "SUSDM":"Exceeds Max TDD",
  "SUSLSG":"Low Suspend",
  "SUSPLSG":"Predictive Low Suspend",
  "Pump Restarted":"Pump Restarted",
  "Meter BG Now":"Meter BG Now",
  "Sensor Exp in 2 Hours":"Sensor Exp in 2 Hours",
  "Sensor Exp in 6 Hours":"Sensor Exp in 6 Hours",
  "Sensor Exp in 30 Min":"Sensor Exp in 30 Min",
  "Sensor Calibration Error":"Sensor Calibration Error",
  "Sensor Error":"No Readings",

  "Device Settings Report":"Device Settings Report",
  "24h Total":"24h Total",
  "Device Settings at":"Device Settings at",
  "Start":"Start",
  "Combo/Ext Bolus":"Combo/Ext Bolus",
  "Time Format":"Time Format",
  "Device Options（CGM System)":"Device Options (CGM System)",
  "Device Options（Insulin Pump)":"Device Options (Insulin Pump)",
  "Dispay Settings (Screen)":"Dispay Settings (Screen)",
  "Dispay Settings (Backlight)":"Dispay Settings (Backlight)",
  "Graph Range":"Graph Range",
  "Range":"Range",
  "Repeat":"Repeat",
  "Glucose Alerts":"Glucose Alerts",
  "Alert Silence":"Alert Silence",

  "Create":"Create",
  "Event Filter":"Event Filter",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Ketone",
  "Injection":"Injection",
  "Other":"Other",
  "Event Type":"Event Type",
  "Details":"Details",
  "Notes":"Notes",
  "Source":"Source",
  "edit":"Edit",
  "Action":"Action",
  "EventReport":"Event Summary Report",
  "By Date":"By Date",
  "By Category":"By Category",
  "Event Summary":"Event Summary",
  "No data":"No data",
  "No1":"No",
  "data1":"data",
  "#":"#",
  "BG Summary":"BG Summary",
  "Carbs Summary":"Carbs Summary",
  "Injection Summary":"Injection Summary",
  "Exercise Summary":"Exercise Summary",
  "Input Notes":"Enter a note",

  "Profile":"Profile",
  "Complications":"Complications",
  "Concomitant diseases":"Concomitant diseases",
  "Suggestion":"Suggestions",
  "Coronary heart disease":"Coronary heart disease",
  "High blood lipids":"High blood lipids",
  "High blood pressure":"High blood pressure",
  "Kidney disease":"Kidney disease",
  "Neuropathy":"Neuropathy",
  "Obesity":"Obesity",
  "Peripheral arterial disease":"Peripheral arterial disease",
  "Retinopathy":"Retinopathy",
  "Smoking addiction":"Smoking addiction",
  "Enter date":"Enter date",
  "Enter suggestion":"Enter suggestion",
  "Enter Notes":"Enter Notes",
  "Select":"Select",
  "Prescription":"Prescription",
  "Medicine":"Medicine",
  "Dose":"Dose",
  "Enter medicine":"Enter medicine",
  "Enter dose":"Enter dose",
  "Enterdis":"Enter concomitant diseases",
  "Add note":"Add note",
  "Add Content":"Maximum length is 1000 characters.",
  "Other suggestions":"Other suggestions",
  "OK":"OK",
  "HCP":"HCP",
  "Content":"Content",
  "Records Report":"Records Report",

  "Quick Print":"Quick Print",
  "Quick Print Settings":"Quick Print Settings",
  "Select duration":"Select duration",
  "One Week":"One Week",
  "One Month":"One Month",
  "One Quarter":"One Quarter",
  "End date":"End date",
  "Yesterday":"Yesterday",
  "Last Sunday":"Last Sunday",
  "Last Saturday":"Last Saturday",
  "Last Day of Last Month":"Last Day of Last Month",
  "Last Day of Last Quarter":"Last Day of Last Quarter",
  "Customized":"Customize",
  "Week Filter":"Week Filter",
  "Select reports to print":"Select reports to print",
  "Daily Summary":"Daily Summary",
  "Day By Day Overview":"Day by Day Overview",
  "Sensor Overlay":"Sensor Overlay",
  "Trend Analysis":"Trend Analysis",
  "Logbook":"Logbook",
  "Device Settings Review":"Device Settings Review",
  "createReport":"Create Report",

  "Segment Analysis":"Segment Analysis",
  "Sensor Glucose Profile":"Sensor Glucose Percentile",
  "# of Boluses":"# of Boluses",
  "Bolus Insulin":"Bolus Insulin",
  "Basal Pattern":"Basal Pattern",
  "Segment Analysis Report":"Segment Analysis Report",
  "Avg Glucose":"Avg. Glucose",
  "Below":"Below",
  "In Target Range":"In Target Range",
  "Coefficient of variation":"Coefficient of variation",
  "% Time CGM Active":"% Time CGM Active",
  "est_a1c_t1":"Estimated A1C:",
  "est_a1c_t2":"calculated from SG values",
  "est_a1c_t3":"Note: Estimated A1C does not replace lab measurement",

  "acceptTip":" has permitted you to remotely view his/her health information.",
  "cancelTip":" has stopped permitting you to remotely view his/her health information. You can apply again if necessary.",
  "rejectTip":" has rejected your remote view application.",
  "Read":"Read",

  "Connection":"Connection",
  "connections1":"Connections",
  "Add Connection":"Add Connection",
  "SG":"SG",
  "Active Insulin":"Active Insulin",
  "Stop following":"Stop following",
  "Enter username (email)":"Enter username (email)",
  "Search results":"Search results",
  "Send request":"Send request",
  "View graphs":"View graphs",
  "Agree":"Agree",
  "Deny":"Deny",
  "Remove":"Remove",
  "Cancel Requset":"Cancel Requset",
  "Remark":"Remark",

  "Warm up":"Warm up",
  "Monitoring":"Monitoring",
  "Transmitter Error":"Transmitter Error",
  "Sensor Failure":"Sensor Failure",
  "Sensor Expired":"Sensor Expired",
  "Lost Sensor":"Lost Sensor",
  "Not Calibrated":"Not Calibrated",
  "Calibrating":"Calibrating",
  "Calibration Needed":"Calibration Needed",
  "Calibration Error":"Calibration Error",
  "Charging Battery":"Charging Battery",
  "Battery Charged":"Battery Charged",

  "To be filled":"To be filled",
  "Filled with insulin":"Filled with insulin",
  "Priming":"Priming",
  "Priming completed":"Priming completed",
  "Inserting needle":"Inserting needle",
  "Patch activated":"Patch activated",
  "Delivering Basal":"Delivering Basal",
  "Exceeds Max 1 Hour Delivery":"Exceeds Max 1 Hour Delivery",
  "Exceeds Max TDD":"Exceeds Max TDD",
  "Suspend":"Suspend",
  "Occlusion Detected":"Occlusion Detected",
  "Patch Expired":"Patch Expired",
  "Empty Reservoir":"Empty Reservoir",
  "Patch Error":"Patch Error",
  "Pump Base Error":"Pump Base Error",
  "Patch Battery Depleted":"Patch Battery Depleted",
  "Magnetic sensor not calibrated":"Magnetic sensor not calibrated",

  "Patient Profile":"Patient Profile",

  "On":"On",
  "on":"On",
  "Off":"Off",
  "off":"Off",

  "CORONARY_HEART_DISEASE":"Coronary heart disease",
  "HIGH_BLOOD_LIPIDS":"High blood lipids",
  "HIGH_BLOOD_PRESSURE":"High blood pressure",
  "KIDNEY_DISEASE":"Kidney disease",
  "NEUROPATHY":"Neuropathy",
  "OBESITY":"Obesity",
  "PERIPHERAL_ARTERIAL_DISEASE":"Peripheral arterial disease",
  "RETINOPATHY":"Retinopathy",
  "SMOKING_ADDICTION":"Smoking addiction",

  "saveTip":"Saved successfully.",
  "changePaTip":"Your password has been changed.",
  "enterEmTip":"Enter your email address.",
  "verErrTip":"Verification code incorrect.",
  "chooseEventTip":"Choose events to print",
  "chooseDataTip":"Select data to print",
  "dateWrongTip":"The end date cannot be earlier than the start date.",
  "infoWrongTip":"Please fill in all required fields.",
  "createdSuccssTip":"Created successfully", // update
  "selectData":"Select data to save",

  "acceSu":"Accepted connection request",
  "acceEr":"Failed to add new connection",
  "rejeSu":"Rejected connection request",
  "rejeEr":"Failed to reject request",

  "userNotExist":"The username does not exist.",
  "Password incorrect":"Password incorrect.",
  "UserType incorrect":"Incorrect user type",

  "registSuccess":"Your account has been successfully created.",
  "registFailed":"Failed to register a new account.",
  "sentSuccess":"Message sent successfully",
  "sentFailed":"Failed to send message",
  "Input error":"Input error",

  "deletePtip":"Are you sure you want to delete these patients?",
  "deleteEvents":"Are you sure you want to delete these events?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"Are you sure you want to delete ?",
  "confirm":"Confirm",
  "deleteSuccess":"Deleted successfully",
  "deleteFailed":"Failed to delete item",
  "modifySuccess":"Changed successfully",
  "modifyFailed":"Failed to change",
  "createSuccess":"Created successfully",
  "createFailed":"Create failed",
  "editSuccess":"Edit successfully",
  "editFailed":"Edit failed",
  "Time overlapped":"The sessions you selected overlapped each other.",

  "stopFollow":"Are you sure you want to stop following this patient?",
  "CancelTip1":"Are you sure to you want to delete this connection?",

  "Warning":"Warning",
  "agreeConnect":"If you click “Agree” to accept the connection request, your health data will become available to the new connection.", // update
  "denyConnect":"Are you sure you want to reject the connection request?",
  "deleteConnect":"Are you sure you want to delete this connection? If you delete him/her, the connection will not be able to view your health data any more.",

  "Choose the events to print":"Choose the events to print",
  "tryAgain":"Try again",
  "username and password is required":"username and password is required",
  "A name is required":"A name is required",
  "username is required":"Username is required",
  "The date choose wrong":"The date choose wrong",
  "Date no more than 14 days":"You cannot select more than 14 days.",

  "CancelTip":"Are you sure you want to delete the connection?",
  "removeConnect":"Deleted successfully",

  "dateErr1":"You cannot select more than 90 days.",
  "dateErr2":"The end date cannot be earlier than the start date.",

  "Not Filled":"Unspecified",
  "Today":"Today",
  "duration":"Duration",
  "interval":"Interval",
  "7 days":"7 days",
  "14 days":"14 days",
  "30 days":"30 days",
  "90 days":"90 days",
  "g":"g",

  "Sound+Vibrate":"Audio+Vibrate",
  "Sound":"Audio",
  "Vibrate":"Vibrate",
  "Silent":"Do not disturb",
  "1":"Once",
  "2":"Daily",
  "noMes":"There is no message.",
  "noConnect":"There is no connection.",
  "Customize":"Customize",
  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"Jan",
  "Feb":"Feb",
  "Mar":"Mar",
  "Apr":"Apr",
  "May":"May",
  "Jun":"Jun",
  "Jul":"Jul",
  "Aug":"Aug",
  "Sep":"Sep",
  "Oct":"Oct",
  "Nov":"Nov",
  "Dec":"Dec",
  "ApplyTip":" request to view your data.",
  "noReadings":"No Readings",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"Uploaded Data",
  "daop_uploaded_data_text":"The data is from EasyTouch App or EasyView iPad App.",
  "daop_realtime_data":"Real-time Data",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"(U)",
  "ins_unit2":"U",
  "basal_unit":"(U/H)",
  "basal_unit2":"U/H",
  "dump_last":"Dump End",

  // 告警
  "Alerts_Patch_Battery_Low":"Patch Battery Low",    // 0
  "Alerts_Patch_Battery_Depleted":"Patch Battery Depleted",
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Low Reservoir",
  "Alerts_Empty_Reservoir":"Empty Reservoir",
  "Alerts_Patch_Expiration_Advisory":"Patch Expiration Advisory",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Patch Expired",
  "Alerts_Patch_Error":"Patch Error",
  "Alerts_Pump_Base_Error":"Pump Base Error",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Occlusion Detected",
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Predictive Low Suspend",
  "Alerts_Low_Suspend":"Low Suspend",
  "Alerts_Auto_Off":"Auto Off",    // 19

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Lost Sensor",   // 100
  "Alerts_Transmitter_Battery_Low":"Transmitter Battery Low",
  "Alerts_Charge_Transmitter":"Charge Transmitter",
  "Alerts_Sensor_Error":"No Readings",
  "Alerts_Transmitter_Error":"Transmitter Error",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Sensor Failure",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"Meter BG Now",
  "Alerts_Sensor_Exp_in_6_Hours":"Sensor Exp in 6 Hours",
  "Alerts_Sensor_Exp_in_2_Hours":"Sensor Exp in 2 Hours",
  "Alerts_Sensor_Exp_in_30_Min":"Sensor Exp in 30 Min",
  "Alerts_Sensor_Expired":"Sensor Expired",
  "Alerts_Rapid_Rise":"Rapid Rise",
  "Alerts_Rapid_Fall":"Rapid Fall",
  "Alerts_High_Predicted":"High Predicted",
  "Alerts_Low_Predicted":"Low Predicted",
  "Alerts_High_Glucose":"High Glucose",
  "Alerts_Low_Glucose":"Low Glucose",
  "Alerts_Below_3.1_mmol/L":"Below 3.1 mmol/L",  // 121
  "Alerts_Transmitter_Battery_Low_2":"Transmitter Battery Low",

  "Alerts_PDM_Battery_Low":"PDM Battery Low",
  "Alerts_Replace_Battery":"Charge PDM Now",

  "Alerts_Auto_Mode_Exit":"Auto Mode Exit",
  "Alerts_PDM_Error":"PDM Restart",
  // Alert页面
  "Alert":"Alert",
  "Alerts":"Alerts",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Pump",
  //"CGM":"CGM",
  "alert_Time":"Time",
  "alert_Type":"Type",

  "Out Of Range": "Out Of Range",

  "Charge Transmitter":"Charge Transmitter",
  "High Predicted":"High Predicted",
  "Low Predicted":"Low Predicted",

  "t1221_Auto_Mode":"Auto Mode",
  "t1221_Time_in_Auto_Mode":"Time in Auto Mode",
  "t1221_Average_SG_SD":"Average SG ± SD",
  "t1221_Time_in_Target_Range":"Time in Target Range",
  "t1221_Time_above_Range":"Time above Range",
  "t1221_Time_below_Range":"Time below Range",
  "t1221_Auto_Basal_per_day":"Auto Basal (per day)",
  "t1221_Auto_Bolus_per_day":"Auto Bolus (per day)",
  "t1221_Auto_Mode_Exits":"Auto Mode Exits",
  "t1221_No_Sensor_readings":"No Sensor readings",
  "t1221_Max_Delivery":"Max Delivery",
  "t1221_Min_Delivery":"Min Delivery",

  "t1222_autoModeBasal":"Auto Mode Basal",
  "t1222_autoModeCorrBolus":"Auto Mode Correct Bolus",
  "t1222_autoSnack":"Auto Snack",
  "t1222_autoBreakfast":"Auto Breakfast",
  "t1222_autoLunch":"Auto Lunch",
  "t1222_autoDinner":"Auto Dinner",
  "t1222_autoExercise":"Auto Exercise",
  "t1222_Snack":"Snack",
  "t1222_auto_basal":"Auto Basal",
  "t1222_auto_bolus":"Auto Bolus",
  "t1222_Auto_Mode":"Auto Mode",
  "t1222_Time_in_Auto_Mode":"Time in Auto Mode(%)",
  "t1222_Avg_SD":"Avg.(mmol/L)±SD",
  "t1222_Target_Range":"Target Range(%)",
  "t1222_Above_Range":"Above Range(%)",
  "t1222_Below_Range":"Below Range(%)",
  "t1222_Auto_Mode_Exits":"# of Auto Mode Exits",


  "t0805_User_Management":"User Management",
  "t0805_Patient_Management":"Patient Management",
  "t0805_Operation_History":"Operation History",
  "t0805_User_List":"User List",
  "t0805_User":"User",
  "t0805_Time":"Time",
  "t0805_Operation_Type":"Operation Type",
  "t0805_Back":"Back",
  "t0805_Add":"Add",
  "t0805_Delete":"Delete",
  "t0809_Add_User":"Add User",
  "t1028_Pattern_C":"Pattern C",
  "t1028_Pattern_D":"Pattern D",
  "t1029_Auto_meal_bolus":"Auto meal bolus",
  "t1029_Auto_mode_correction_bolus":"Auto mode correction bolus",
  "t1029_Sick":"Sick",
  "t1029_Auto_Mode_Feature":"Auto Mode Feature",
  "t1029_Target_SG":"Target SG",
  "t1029_Auto_Meal_Handling":"Auto Meal Handling",
  "t1029_Total_Daily_Dose":"Total Daily Dose",
  "t1029_Pump_Light":"Pump Light",
  "t1029_Alerts_for_Hypo":"Alerts for Hypo",
  "t1102_Out_of_Range":"Out of Range",
  "t1102_Command_Reminder":"Command Reminder",
  "t1102_Alarms_Alerts_on_APP":"Alarms & Alerts on APP",
  "t1102_Alarms_on_App":"Alarms on App",
  "t1102_Alerts_on_App":"Alerts on App",
  "t1102_Factory_Calibration":"Factory Calibration",
  "t1102_Alerts_for_Low":"Alerts for Low",
  "t1102_Alerts_for_High":"Alerts for High",
  "t1102_Alerts_for_Others":"Alerts for Others",
  "t1102_Adjustment":"Adjustment",
  "t1102_Suggested":"Suggested",
  "t1103_Glucose":"Glucose",
  "t1103_CGM":"CGM",
  "t1103_Insulin":"Insulin",
  "t1103_Carbs":"Carbs",
  "t1103_Exercise":"Exercise",
  "t1103_Min_Max":"Min/Max",
  "t1103_Target_Range":"Target Range",
  "t1103_Overall_Tine_In_Range":"Overall: Time In Range",
  "t1103_Basal":"Basal",
  "t1103_Bolus":"Bolus",
  "t1103_Basal_Bolus":"Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range":"Auto Mode: Time In Range",
  "t1103_Time_below_range":"Time below range",
  "t1103_Time_above_range":"Time above range",
  "t1103_Time_in_target_range":"Time in target range",
  "t1103_Incorrect_Password":"Incorrect Password, $1 Attempt left, please enter the correct Password.",
  "t1103_Incorrect_locked":"Failed Attempts exceed the limit, the account has been locked. Please try again in $1 minutes.",
  "t1104_The_data_is_from":"The data is from EasySense App or EasyPatch App.",
  "t1104_Privacy_Policy":"Privacy Policy and Terms of Use",
  "t1104_updated_privacy_policy":"We have updated our privacy policy and terms of use. Please read and agree to all terms to continue using EasyView.",
  "t1104_Disagree":"Disagree",
  "t1104_Agree":"Agree",
  "t1105_Upload_History":"Upload History",
  "t1105_Delete_Data":"Delete Data",
  "t1105_Target_Range":"Target Range",
  "t1105_request_to_view_your_data":"$1 request to view your data.",
  "t1105_Recent_Updates":"Recent Updates",
  "t1108_No_data":"No data",
  "t1108_Pump_Bash_SN":"Pump Base SN",
  "t1108_Transmitter_SN":"Transmitter SN",
  "t1112_Normal_Glucose":"Normal Glucose",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Manual Bolus or Modified Bolus",
  "t1112_Auto_Mode_Started":"Auto Mode Started",
  "t1112_Auto_Mode_Exit":"Auto Mode Exit",
  "t1112_Normal_Bolus":"Normal Bolus",
  "t1112_Extended_Bolus":"Extended Bolus",
  "t1112_Combo_Bolus":"Combo Bolus",
  "t1112_Carbs":"Carbs",
  "t1112_Glucose":"Glucose",
  "t1112_BG":"BG",
  "t1112_Audio":"Audio",
  "t1112_Tone":"Tone",
  "t1112_Audio_Options":"Audio Options",
  "t1112_Weight_Unit":"Weight Unit",
  "t1112_Height_Unit":"Height Unit",
  "t1112_Not_available":"Not available",
  "t1112_Number":"Number",
  "t1112_days":"# days",
  "t1112_min":"min",
  "t1113_days":"days",
  "t1215_Security":"Security",
  "t1215_MFA":"Multi-factor authentication (MFA)",
  "t1215_Enter_verification_code":"Enter verification code",
  "t1215_Multi_factor_ON":"Multi-factor authentication is ON. Verification code has been sent to $1 Please submit verification code.",
  "t1215_Verification_code_incorrect":"Verification code incorrect",
  "t1215_Show_Glucose_Value":"Show Glucose Value",
  "t1221_enter_verification_code":"Please enter the 6-digit verification code sent to $1.",
  "t1221_Verification_Success":"Verification Success",
  "t1222_We_will_only_process":"We will only process your Healthcare data through Medtrum App/website with your consent.",
  "t1222_If_you_are_under_years":"If you are under 16 years of age, you will need the consent of your parent or legal guardian to register in this App.",
  "t1221_register_cn":"You have the right not to upload any device data to the App, in which case the data will not be accessible to others. If you choose not to register in Medtrum App/website, the only record of your Healthcare data is on the device itself. ",
  "t1221_register_eu":"If you choose to register your Medtrum account and access our App using the account, the healthcare data recorded on the App will be uploaded to our server in Europe and be held for 2 years. You have the right not to upload any device data to the App, in which case the data will not be accessible to others. If you choose not to register in Medtrum App/website, the only record of your Healthcare data is on the device itself.",
  "t1221_register_follow":"We will only process your Healthcare data through Medtrum App/website with your consent.",
  "t1222_Terms_of_Use":"the Terms of Use of Medtrum",
  "t1222_Privacy_Policy":"the Privacy Policy of Medtrum",
  "t1222_Create_Account":"Create Account",
  "t1222_Back":"Back",
  "t1222_Verify_your_account":"Verify your account",
  "t1222_please_check_your_account":"We will send a Verification Code to $1, please check your account.",
  "t1222_I_Agree_to":"I Agree to $1",
  "t1223_Invalid_Verification_Code":"Invalid Verification Code. Please try again.",
}

//export default  {
//export {
//  enMessages
//}



// WEBPACK FOOTER //
// ./src/lang/en.js